import { useRouter } from "next/router";
import Image from "next/image";
import GameView from "components/GameView";
import { useGameContext } from "src/contexts/GameContext";
import Content from "components/Layout/Content";
import EPButton from "components/UI/EPButton";
import clsx from "clsx";
import { AiFillPlayCircle } from "react-icons/ai";
import { Dialog } from "@headlessui/react";
import GamePageLeaderBoard from "components/LeaderBoard/GamePageLeaderBoard";
import AddToFavButton from "components/AddToFavButton";
import RatingCard from "components/Rating/RatingCard";
import MinimalAppCard from "components/AppsList/MinimalAppCard";
import { cn } from "utils/styling";
import useScrollable from "hooks/useScrollable";
import FadeTransition from "components/FadeTransition";
import { useRef } from "react";
import { CgChevronLeft, CgChevronRight } from "react-icons/cg";
import { getGamePath, getPlayPath } from "constants/routes.const";
import dynamic from "next/dynamic";
import { mangaQuizGame } from "data/manga-quiz";

const ShareDialog = dynamic(() => import("components/ShareDialog"), {
  ssr: false,
});
const AppContainer = ({ item, similarGames }) => {
  const router = useRouter();
  const { showGame, setShowGame, setGameId } = useGameContext();
  function handleOnGameStart() {
    if (item.game_id === mangaQuizGame.game_id) {
      router.push(getPlayPath(item.pathname));
      return;
    }
    setShowGame(true);
    setGameId(item?.ws?.gid || item.game_id);
  }

  return (
    <>
      <div className=" my-2 overflow-hidden text-center">
        <div className="relative flex flex-col gap-2 overflow-hidden px-0 text-center  md:grid  md:grid-cols-12 md:px-4 xl:px-8">
          <div
            className={clsx(
              "relative  overflow-hidden text-center",
              "md:col-span-8 md:col-start-1 lg:col-span-7"
            )}
          >
            <div>
              <div
                className={cn(
                  "relative aspect-[22/10] overflow-hidden rounded-none md:rounded-t-md"
                )}
              >
                <div className="relative flex h-full w-full overflow-hidden">
                  <div className="relative w-full bg-secondary-base">
                    <Image
                      src={item.bannerImageUrl}
                      sizes="(max-width:767px) 100vw, 50vw"
                      fill={true}
                      style={{ objectFit: "cover" }}
                      alt={item.title}
                      priority
                    />
                  </div>
                </div>
                <button
                  className={"absolute inset-0"}
                  onClick={handleOnGameStart}
                  aria-label={"Play " + item.title}
                ></button>
              </div>
              <div
                className="flex  justify-between gap-4
              rounded-none bg-tertiary-base
               p-2  text-white md:rounded-b-md
              "
              >
                {/* left */}
                <div className="flex items-center justify-start gap-2">
                  <Image
                    src={item.imageUrl}
                    alt={item.imageAlt}
                    width={44}
                    height={44}
                    priority
                    className="h-11 w-11 rounded shadow"
                  />
                  <div className="flex flex-row flex-wrap items-center gap-1">
                    <span className="text-start text-sm font-medium md:text-base">
                      {item.title}
                    </span>
                    {/* <RatingCard rating="5.0" /> */}
                  </div>
                </div>
                {/* right */}
                <div className="flex items-center justify-end gap-2">
                  <div className="gap flex items-center justify-end">
                    {item?.isLeaderboard ? (
                      <div className=" w-10">
                        <GamePageLeaderBoard game={item} />
                      </div>
                    ) : null}
                    <div className=" w-10">
                      <AddToFavButton small game={item} noBg />
                    </div>
                    <div className=" w-10">
                      <ShareDialog
                        title={item.title}
                        path={getGamePath(item.pathname)}
                        text={item.description}
                      />
                    </div>
                  </div>
                  <EPButton
                    onClick={handleOnGameStart}
                    aria-label={`Play ${item.title}`}
                    className={
                      "shimmerFx absolute bottom-6 flex h-11 min-w-max -translate-y-full items-center justify-center gap-1 overflow-hidden rounded-md px-6 py-1 md:relative md:bottom-0 md:translate-y-0"
                    }
                  >
                    <AiFillPlayCircle size={30} /> PLAY NOW
                  </EPButton>
                </div>
              </div>
            </div>
          </div>
          <div className="flex overflow-hidden md:col-span-4 lg:col-span-5">
            <div className="flex flex-1 flex-col items-start gap-2 overflow-hidden rounded py-0 md:py-4">
              <div className="mb-1 hidden  w-full items-center justify-between  px-4 text-base font-medium md:flex">
                Play More Games
              </div>
              <MoreGames games={similarGames} />
            </div>
          </div>
        </div>
      </div>

      {showGame && (
        <Dialog open={true} onClose={() => {}}>
          <div className="max-w-screen fixed inset-0 z-10 transform-gpu bg-primary-base">
            <GameView game={item} />
          </div>
        </Dialog>
      )}
    </>
  );
};
export default AppContainer;

function MoreGames({ games }) {
  const elementRef = useRef(null);
  const { left, right } = useScrollable(elementRef, {
    left: false,
    right: true,
  });

  return (
    <div className="relative flex w-full flex-1">
      <div
        ref={elementRef}
        className="no-scrollbar relative grid w-full flex-1 snap-x snap-mandatory scroll-ps-2 grid-flow-col grid-rows-1 gap-2 overflow-x-auto rounded px-2 md:grid-rows-2"
      >
        {games.map((item, index) => {
          return (
            <div
              className={cn(
                "aspect-square h-20  snap-start md:h-full",
                !index && "min-h-full"
              )}
              key={index}
            >
              <MinimalAppCard
                key={item.game_id + index}
                item={item}
                index={index}
                cardSize={"100%"}
                imageOptions={{
                  width: 80,
                  height: 80,
                  sizes: "(max-width: 640px) 22vw, 12vw",
                }}
              />
            </div>
          );
        })}
      </div>
      {/* scroll wrapper */}
      {/* left */}

      <FadeTransition show={left}>
        <div
          className="absolute inset-y-0 left-0 flex w-10 cursor-pointer items-center justify-center bg-gradient-to-l from-transparent to-primary-base"
          onClick={() => {
            elementRef.current.scrollBy({
              left: -elementRef.current.clientWidth,
              behavior: "smooth",
            });
          }}
        >
          <CgChevronLeft size={24} />
        </div>
      </FadeTransition>

      {/* right */}

      <FadeTransition show={right}>
        <div
          className="absolute inset-y-0 right-0 flex w-10 cursor-pointer items-center justify-center bg-gradient-to-r from-transparent to-primary-base"
          onClick={() => {
            elementRef.current.scrollBy({
              left: elementRef.current.clientWidth,
              behavior: "smooth",
            });
          }}
        >
          <CgChevronRight size={24} />
        </div>
      </FadeTransition>
    </div>
  );
}
